import React from 'react';

export const GoogleSpreadsheetResultIcon = (): React.JSX.Element => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g transform="translate(2.875, 0)">
			<rect x="-1.875" y="1" width="14" height="14" rx="2" fill="#20A464" />
			<rect x="-0.125" y="7.25" width="10" height="1.5" fill="white" />
			<rect x="-0.125" y="4.25" width="10" height="1.5" fill="white" />
			<rect x="-0.125" y="10.25" width="10" height="1.5" fill="white" />
			<rect
				x="10.375"
				y="4.25"
				width="7.5"
				height="1.5"
				transform="rotate(90 10.375 4.25)"
				fill="white"
			/>
			<rect
				x="5.875"
				y="4.25"
				width="7.5"
				height="1.5"
				transform="rotate(90 5.875 4.25)"
				fill="white"
			/>
			<rect
				x="1.375"
				y="4.25"
				width="7.5"
				height="1.5"
				transform="rotate(90 1.375 4.25)"
				fill="white"
			/>
		</g>
	</svg>
);
